import React from 'react';
import Navigation from '../../components/navigation'
import {Link} from 'react-router-dom'
import './class.css'
export default class venue extends React.Component {
    render(){
        return (
            <main>
                <Navigation tab="train"></Navigation>
                <div className="detail_title"><Link to="/train">培训</Link> / 课程设置</div>
                {this.props.match.params.id == 1 &&
                    <div className="train_class_pic">
                        <img src={require('./../../pic/class_01.jpg')} alt=""></img>
                        <p>成人班</p>
                        <p>适宜年龄：<b>18岁以上</b></p>
                        <p>根据成人运动和思维的特点进行制定训练计划，整节课90分钟。除了让学员熟练的掌握击剑的技战术以外，还要让学员体验冷兵器时代优雅的骑士精神，感受决斗的快感与胜利的喜悦。让您在紧张的工作（学习）之余感受到击剑运动的迷人之处，并且通过击剑塑造形体美，时尚与健康已为击剑代言。</p>
                    </div>
                }
                {this.props.match.params.id == 2 &&
                    <div className="train_class_pic">
                        <img src={require('./../../pic/class_02.jpg')} alt=""></img>
                        <p>青少年班</p>
                        <p>适宜年龄：<b>13岁~18岁</b></p>
                        <p>教练根据青少年阶段的年龄性格特点来制定教学计划，通过学习击剑技术使学员获得高度集中的注意力，用战术训练提高他们的逻辑思维能力。在辅助以力量和耐力训练提高学员的身体素质和锻炼顽强的意志品质。</p>
                    </div>
                }
                {this.props.match.params.id == 3 &&
                    <div className="train_class_pic">
                        <img src={require('./../../pic/class_03.jpg')} alt=""></img>
                        <p>儿童班</p>
                        <p>适宜年龄：<b>5岁~12岁</b></p>
                        <p>有助于培养和提高孩子的耐心、专注力和身体技能，使他们在击剑运动中更有竞争性，做到超越自我。每位教练每次带课学员不超过8人，我们拥有高素质的教练，课程注重于培养对击剑的兴趣和热情，及通过击剑运动锻炼孩子的身体协调性，提高注意力，逻辑思维、独立思考的能力。教练用耐心、真心、责任心让您的孩子学的开心，来换取您的放心。</p>
                    </div>
                }
               
            </main>
        )
    }
};